module.exports = __webpack_public_path__ + "static/media/forMSMEBanner.5b820238.webp";